import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor untuk menambahkan token Authorization pada setiap request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor untuk menangani response dan refresh token jika expired
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem('refreshToken');

    if (error.response && error.response.status === 401 && refreshToken && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const response = await api.post('/auth/refresh-token', { refreshToken });

        if (response.status === 200) {
          localStorage.setItem('accessToken', response.data.accessToken);
          localStorage.setItem('refreshToken', response.data.refreshToken);
          originalRequest.headers['Authorization'] = `Bearer ${response.data.accessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      }
    } else if (error.response && error.response.status === 500) {
      console.error('Server error:', error);
      alert('Server error. Please try again later.');
    } else if (error.response && error.response.status === 404) {
      console.warn('API endpoint not found:', error.response.config.url);
    } else if (!error.response) {
      console.error('Network error or server is unreachable:', error);
      alert('Network error. Please check your connection.');
    }

    return Promise.reject(error);
  }
);

// 🔹 Fungsi API untuk PartnerJoinPage
const ApiService = {
  // Ambil daftar kategori organisasi
  getCategories: async () => {
    const res = await api.get('/organizations/categories');
    return res.data.data;
  },

  // Ambil daftar tipe berdasarkan kategori
  getTypesByCategory: async (categoryId) => {
    const res = await api.get(`/organizations/categories/${categoryId}/types`);
    return res.data.data;
  },
};

export default ApiService;
